<template>
  <div class="post-details">
    <post :post="post" :details="true" />
    <report-dialog
      :postId="post.id"
      :dialog="reportDialog"
      @onCloseDialog="closeDialog"
    />
    <dialog-box
      :showDialog="dialog"
      :width="500"
      title="Excluir postagem"
      text="Tem certeza que deseja excluir a postagem?"
      btnText="Excluir"
      btnColor="warning-color"
      btnTwoText="Cancelar"
      @onBtnClicked="destroyPost"
      @onBtnTwoClicked="closeDialog"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Post from '@/components/cards/Post.vue';
import ReportDialog from '@/components/dialogs/ReportDialog.vue';
import DialogBox from '@/components/feedbacks/DialogBox.vue';

export default {
  name: 'Details',
  components: {
    Post,
    ReportDialog,
    DialogBox,
  },
  data() {
    return {
      reportDialog: false,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(['getPost', 'toolbarNavActions', 'currentPrincipal']),
    post() {
      return this.getPost || { postable: {}, authorable: {} };
    },
  },
  watch: {
    getPost(value) {
      if (value) {
        let postActions;
        if (this.post && this.currentPrincipal
            && (this.post.authorable.id === this.currentPrincipal.id)) {
          postActions = [
            {
              title: 'Deletar',
              method: this.deletePostDialog,
            },
            {
              title: 'Editar',
              method: this.editPost,
            },
          ];
        } else {
          postActions = [
            {
              title: 'Reportar',
              method: this.reportPostDialog,
            },
          ];
        }
        const navOptions = {
          back: {
            has: true,
            path: 'feedList',
          },
          spacer: {
            has: true,
          },
          moreOptions: {
            has: true,
            actions: postActions,
          },
        };
        this.setupToolbar(true);
        this.setToolbarText(this.post.title);
        this.setupActions(navOptions);
      }
    },
  },
  mounted() {
    this.findPost(this.$route.params.postId);
  },
  destroyed() {
    this.defaultToolbar();
  },
  methods: {
    ...mapActions([
      'findPost',
      'changeToolbarNav',
      'deletePost',
      'setToolbarText',
      'setupToolbar',
      'setupActions',
      'defaultToolbar',
    ]),
    reportPostDialog() {
      this.reportDialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.reportDialog = false;
    },
    deletePostDialog() {
      this.dialog = true;
    },
    destroyPost() {
      this.deletePost(this.post.id);
      this.closeDialog();
      this.$router.push({ name: 'feedList' });
    },
    editPost() {
      this.$router.push({
        name: 'EditPost',
        params: {
          postId: this.getPost.id,
          post: this.getPost,
          backPath: 'postDetails',
        },
      });
    },
  },
};
</script>
<style lang="scss">
.post-details {
  padding: 16px;
}

</style>
